<template>
  <div id="anotacoes">
    <sub-header-grey v-if="propShowHeader"
                     class="row mt-3 mb-1">
      <div class="d-flex justify-content-between pb-1 pl-2">
        Anotações de Cadastro
      </div>
    </sub-header-grey>
    <b-row class="mb-2">
      <b-col>
        <b-row v-if="tipo_registro === 'CASAMENTO'"
               class="my-2">
          <b-col cols="12"
                 class="mb-2">
            <label class="label"
                   for="">
              Inserir anotação para:
            </label>
          </b-col>
          <b-col cols="12"
                 class="d-inline-flex">
            <b-form-radio :id="`conjuge_1`"
                          v-model="conjuge"
                          value="conjuge_1"
                          class="mr-4"
                          @change="changeAnotacaoConjuge()">
              Cônjuge 1
            </b-form-radio>
            <b-form-radio :id="`conjuge_2`"
                          v-model="conjuge"
                          value="conjuge_2"
                          @change="changeAnotacaoConjuge()">
              Cônjuge 2
            </b-form-radio>
          </b-col>
        </b-row>

        <FormAnotacoesCadastro v-if="tipo_registro === 'CASAMENTO'"
                               :prop-anotacoes="anotacoesConjuge"
                               :prop-options-anotacao="optionsAnotacao"
                               :prop-selects-options="selectsOptions"
                               :prop-max-length="maxlength"
                               :prop-placeholder="placeholder"
                               :prop-orgao-emissor-options="orgao_emissor_options"
                               @changeTipo="changeTipo()"
                               @changeAnotacao="changeAnotacao"
                               @deleteAnotacao="deletarAnotacaoConjuge"
                               @updateOrgao="updateOrgao()"
                               @changeCidades="changeCidades" />

        <FormAnotacoesCadastro v-else
                               :prop-anotacoes="anotacoes"
                               :prop-options-anotacao="optionsAnotacao"
                               :prop-selects-options="selectsOptions"
                               :prop-max-length="maxlength"
                               :prop-placeholder="placeholder"
                               :prop-orgao-emissor-options="orgao_emissor_options"
                               @changeTipo="changeTipo()"
                               @changeAnotacao="changeAnotacao"
                               @deleteAnotacao="deletarAnotacao"
                               @updateOrgao="updateOrgao()"
                               @changeCidades="changeCidades" />
      </b-col>
      <b-col cols="12"
             class="mb-2">
        <button variant="primary"
                class="btn btn-sm btn-outline-primary btn-add-anotacao btn-block my-3"
                :disabled="tipo_registro === 'CASAMENTO' ? anotacoesConjuge.length == 10 : anotacoes.length == 10"
                size="sm"
                @click="novaAnotacao">
          <IconSvg class="icon-add icon--sm mr-1"
                   icon="add" />
          Adicionar Anotação
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  /* icons */
  import deleteRedIcon from '@/assets/icons/delete-red.svg?sprite'

  /* components */
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import FormAnotacoesCadastro from './FormAnotacoesCadastro'

  /* constants */
  import { getOrgaoEmissor } from "@/constants/documentosPessoais"
  import Cidades from "@/constants/repositorio/cidades"

  /* services */
  import EnderecosService from "@/services/Enderecos"
  import AnotacoesCadastroService from "@/services/Registros/AnotacoesCadastroService"

  /* others */
  import { mapGetters } from 'vuex'
  import moment from "moment"

  export default {
    name: "AnotacoesCadastro",
    components: {
      SubHeaderGrey,
      FormAnotacoesCadastro
    },
    props: {
      registroId: {type: Number, default: null},
      propRegistro: { type: Object, default: null},
      propShowHeader: { type: Boolean, default: true}
    },
    inject: ['$validator'],
    data () {
      return {
        registro_id: this.registroId,
        dataTeste: '',
        placeholder: '',
        maxlength: '20',
        deleteRedIcon,
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        anotacao: {},
        orgao_emissor_options: [],
        optionsAnotacao: [
          { value: null, text: 'Escolha a anotação', disabled: false },
          { value: 'rg', text: 'RG', disabled: false },
          { value: 'pis_nis', text: 'PIS/NIS', disabled: false },
          { value: 'passaporte', text: 'Passaporte', disabled: false },
          { value: 'cns', text: 'Cartão Nacional de Saúde', disabled: false },
          { value: 'titulo', text: 'Titulo de Eleitor', disabled: false },
          { value: 'cep', text: 'CEP Residencial', disabled: false },
          { value: 'grupo_sanguineo', text: 'Grupo Sanguíneo', disabled: false },
          { value: 'ctps', text: 'Carteira de Trabalho e Previdência Social', disabled: false },
          { value: 'reservista', text: 'Reservista', disabled: false },
          { value: 'cnh', text: 'Carteira Nacional de Habilitação', disabled: false },
        ],
        //anotacoes:[],
        anotacoes: [
          {
            registro_id: this.registro_id,
            pessoa_id: null,
            tipo_documento: null,
            numero: null,
            serie: null,
            data_emissao: null,
            codigo_orgao_emissor: null,
            data_validade: null,
            zona: null,
            secao: null,
            uf_emissor: null,
            cidade_eleitoral: null,
            cep: null,
            grupo_sanguineo: null,
          }
        ],
        objBody: {
          registro_id: this.registro_id,
          pessoa_id: null,
          tipo_documento: null,
          numero: null,
          serie: null,
          data_emissao: null,
          codigo_orgao_emissor: null,
          data_validade: null,
          zona: null,
          secao: null,
          uf_emissor: null,
          cidade_eleitoral: null,
          cep: null,
          grupo_sanguineo: null,
        },
        selectsOptions: {
          states: [],
          cities: [],
        },
        tipo_registro: null,
        conjuge: 'conjuge_1'
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorio'
      }),
      anotacoesConjuge () {
        const {pessoas} = this.propRegistro

        if (this.conjuge === 'conjuge_1') {
          return this.anotacoes.filter(anotacao => anotacao.pessoa_id === pessoas[0].pessoa_id)
        } else {
          return this.anotacoes.filter(anotacao => anotacao.pessoa_id === pessoas[1].pessoa_id)
        }
      }
    },
    watch: {
      propRegistro () {
        const casamento = this.propRegistro && ['C', 'CR'].includes(this.propRegistro.tipo_registro)

        if (casamento) {
          this.tipo_registro = 'CASAMENTO'

          this.changeAnotacaoConjuge()
        }
      }
    },
    async created () {
      this.selectsOptions.states = await EnderecosService.getStates()
      //this.selectsOptions.states = await getStates()
      await this.init()

      const casamento = this.propRegistro && ['C', 'CR'].includes(this.propRegistro.tipo_registro)

      if (casamento) {
        this.tipo_registro = 'CASAMENTO'

        this.changeAnotacaoConjuge()
      } else {
        this.disableOptions()
      }
    },
    methods: {
      async init () {
        const anotacoes = await AnotacoesCadastroService.getAnotacoes ({
          cartorio_id: this.$store.state.auth.cartorio_id,
          registro_id: this.registro_id
        })
        this.orgao_emissor_options = await getOrgaoEmissor()
        this.anotacoes = anotacoes

        this.changed()

        if (!anotacoes.length) {
          this.novaAnotacao()
        }
        else {
          this.anotacoes.map(anotacao => {
            if (anotacao.data_emissao) {
              anotacao.data_emissao = moment(anotacao.data_emissao).format('YYYY-MM-DD')
            }
            if (anotacao.data_validade) {
              anotacao.data_validade = moment(anotacao.data_validade).format('YYYY-MM-DD')
            }
          })
        }
      },

      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        return moment('1500/01/01').format("YYYY-MM-DD")
      },

      novaAnotacao () {
        let obj = {...this.objBody}
        this.anotacoes.push(obj)

        this.changed()
      },
      async deletarAnotacao (anotacao,index) {
        this.anotacoes.splice(index,1)

        if (this.anotacoes.length == 0) {
          this.anotacoes.push({...this.objBody})
        }
        if (anotacao.registro_anotacoes_cadastro_id) {
          await AnotacoesCadastroService.excludeAnotacoes(anotacao.registro_anotacoes_cadastro_id)
        }
        this.changeTipo()

        this.changed()
      },

      deletarAnotacaoConjuge (anotacao) {
        const index = this.anotacoes.findIndex(anot => {
          const {registro_anotacoes_cadastro_id: anot_id} = anot
          const {registro_anotacoes_cadastro_id: anotacao_id} = anotacao

          return anot_id === anotacao_id
        })

        if (index != -1) {
          this.deletarAnotacao(anotacao, index)
        }
      },
      changeTipo () {
        this.anotacoes.map(anotacao => {
          const dadosInputs = this.verifyMaxLength(anotacao.tipo_documento)
          if (dadosInputs.maxlength != null) {
            this.maxlength = dadosInputs.maxlength
          }
          else {
            this.maxlength = '20'
          }

          this.placeholder = dadosInputs.placeholder

        })

        this.disableOptions()

        this.changed()
      },
      disableOptions () {
        this.optionsAnotacao.forEach(option => {

          const casamento = this.propRegistro && ['C', 'CR'].includes(this.propRegistro.tipo_registro)

          if (casamento) {
            this.disableOptionsCasamento()
          } else {
            const anotacao =  this.anotacoes.find(anotacao => anotacao.tipo_documento === option.value)

            if (anotacao) {
              option.disabled = true
            } else {
              option.disabled = false
            }

            if (option.value == null) {
              option.disabled = false
            }
          }
        })
      },
      disableOptionsCasamento () {
        this.optionsAnotacao.forEach(option => {
          const { pessoas } = this.propRegistro

          const pessoaId = this.conjuge === 'conjuge_1' ? pessoas[0].pessoa_id : pessoas[1].pessoa_id

          const anotacao = this.anotacoes.find(anotacao => {
            const tipo = anotacao.tipo_documento === option.value
            const id = anotacao.pessoa_id === pessoaId
            return tipo && id
          })

          option.disabled = !!anotacao

          if (option.value == null) {
            option.disabled = false
          }
        })
      },
      verifyMaxLength (tipo) {
        let maxlength, placeholder

        switch (tipo) {
        case 'rg':
          placeholder = 'Digite o número'
          maxlength = '9'
          break

        default:
          placeholder = 'Digite o número'
          break
        }
        return {
          maxlength,
          placeholder
        }

      },
      async changeCidades (uf_emissor) {
        const cities = Cidades
        this.selectsOptions.cities = cities.filter(cidade => cidade.codigo_uf == uf_emissor)
      },
      async changeAnotacao (anotacao) {
        if (anotacao.registro_id && anotacao.registro_anotacoes_cadastro_id) {

          this.validateInput(anotacao)

          const data = await AnotacoesCadastroService.updateAnotacoes (anotacao, anotacao.registro_anotacoes_cadastro_id)

        }
        else {
          anotacao.registro_id = this.registro_id
          this.validateInput(anotacao)
          const data = await AnotacoesCadastroService.saveAnotacoes (anotacao)

          this.changed()
          this.init()
        }
      },
      validateInput (anotacao) {
        if (anotacao.codigo_orgao_emissor) {
          anotacao.codigo_orgao_emissor  = anotacao.codigo_orgao_emissor.toString()
        }
        if (anotacao.cidade_eleitoral) {
          anotacao.cidade_eleitoral  = anotacao.cidade_eleitoral.toString()
        }
        if (anotacao.uf_emissor) {
          anotacao.uf_emissor = anotacao.uf_emissor.toString()
        }
      },
      updateOrgao () {
        this.changed()
      },
      changed () {
        const anotacoes = this.anotacoes.filter(anotacao => !!anotacao.tipo_documento)
        this.$emit("onNovaAnotacao", anotacoes)
      },
      changeAnotacaoConjuge () {
        const {pessoas} = this.propRegistro

        setTimeout(() => {
          if (this.conjuge === 'conjuge_1') {
            this.objBody.pessoa_id = pessoas[0].pessoa_id
          } else {
            this.objBody.pessoa_id = pessoas[1].pessoa_id
          }

          this.disableOptionsCasamento()
        }, 100)
      },
    }
  }
</script>

<style scoped>

.btn-add-anotacao:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }
.icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
